module.exports = __webpack_public_path__ + "img/DOC.cc734b65.png";